function initHeaderScroll() {
  const body = document.body;
  
  if (!body.classList.contains('template-index')) {
    return;
  }
  
  const header = document.querySelector('.header');
  const wildmHero = document.querySelector('.wildm-hero');
  
  if (!header || !wildmHero) {
    return;
  }
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        header.classList.add('black');
      } else {
        header.classList.remove('black');
      }
    });
  }, {
    threshold: 0
  });
  
  observer.observe(wildmHero);
}

function initFooterReveal() {
  const footer = document.getElementById('wildmFooter');
  if (!footer) return;

  const main = document.getElementById('main');
  if (!main) return;

  // Spacer sits after #main in the DOM (as a body-level sibling).
  // It has no background so scrolling past #main exposes the fixed footer beneath.
  const spacer = document.createElement('div');
  spacer.id = 'wildmFooterSpacer';

  function syncSpacerHeight() {
    spacer.style.height = footer.offsetHeight + 'px';
  }

  main.after(spacer);
  syncSpacerHeight();

  // Keep spacer height in sync on resize
  const resizeObserver = new ResizeObserver(syncSpacerHeight);
  resizeObserver.observe(footer);

  // Fade in footer content as soon as the spacer starts entering the viewport
  const intersectionObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        footer.classList.add('is-visible');
      } else {
        footer.classList.remove('is-visible');
      }
    });
  }, {
    threshold: 0
  });

  intersectionObserver.observe(spacer);
}

function init() {
  initHeaderScroll();
  initFooterReveal();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}